// extracted by mini-css-extract-plugin
export default {"cardContainer":"Home_cardContainer__IBaB6","message":"Home_message__3PDZ3","card":"Home_card__lxMQh","loader":"Home_loader__Wnrrg"};